module.exports = __webpack_public_path__ + "img/553.944e2964.png";